/*
 * @Description: 分销活动页
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import viewName from '../constant.js'
import {
    getDistributionActivityInfo,
    getDistributionActivityGoodsList
} from '@/models/distributionActivity'
// import {
//     postBindDistributorCode
// } from '@/models/confirmOrder'
import distributionCountDown from './components/distributionCountDown.vue'
import distributionSearch from './components/distributionSearch.vue'
import distributionGoodsList from './components/distributionGoodsList.vue'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import GuideFloating from '@/components/guideFloating/guideFloating'
import InfiniteLoading from 'vue-infinite-loading'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import { wxShare } from '@/utils/wxsdk'

export default {
    name: viewName.distributionActivity,
    components: {
        infiniteLoadData,
        InfiniteLoading,
        distributionCountDown,
        distributionGoodsList,
        distributionSearch,
        GuideFloating,
        appGuideDialog
    },
    data () {
        return {
            reqSuccess: false, // 请求是否成功
            activity_title: '', // 活动标题
            is_activity: true,
            banner_img: '', // 主题图片
            time: 0, // 倒计时
            list: [],
            share: {
                desc: '',
                imgUrl: '',
                title: ''
            },
            page: 1,
            pagesize: 20,
            isload: true,
            goods_name: '', // 搜索名称
            special_id: undefined,
            jumpType: 'home' // 跳转小程序路径
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
        ...mapGetters([
            'wxUserInfo'
        ]),
    },
    created () {

    },
    activated () {
        // this.$emit('setHeader', {
        //     title: this.share.title === '' ? this.activity_title : this.share.title,
        //     showHeader: true,
        //     showLeft: false
        // })
    },
    mounted () {
        this.list = []
        const { special_id } = this.$route.query
        this.special_id = special_id
        if (typeof (this.special_id) !== 'undefined') {
            this.getInfo()
        }
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })

        // /* 绑定分销员 */
        // if (this.wxUserInfo && this.wxUserInfo.token) {
        //     this.postBindDistributionCode(distribution_code)
        // }
    },
    methods: {
        ...mapActions([
            'getNearbySstores',
            'setAppClass'
        ]),
        /**
         * 绑定分销员
         * @param {string} code
         */
        // postBindDistributionCode (code) {
        //     if (code) {
        //         postBindDistributorCode({
        //             distribution_code: code || ''
        //         })
        //     }
        // },
        alertError (message) {
            this.$dialog
                .alert({
                    confirmButtonText: '我知道了',
                    message
                }).then(() => {
                    this.$refs.appGuideDialog.open()
                })
        },
        /**
         * 无限滚动方法
         */
        infinite () {
            this.getGoodsList()
        },
        /**
         * 配置微信分享
         * @param {Object} detail
         */
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    title: detail.title === '' ? this.activity_title : detail.title,
                    imgUrl: detail.imgUrl,
                    desc: detail.desc === '' ? this.special_content : detail.desc,
                })
            }
        },
        /**
         * 跳转下载连接
         */
        downloadApp () {
            this.$router.push({
                path: '/appDownload',
                query: {}
            })
        },
        /*
         * 搜索商品
         */
        onSearch (goodsName) {
            this.goods_name = goodsName
            this.page = 1
            this.list = []
            this.getGoodsList()
        },
        /**
         * 获取分销活动基本信息
         */
        async getInfo () {
            const { distribution_code } = this.$route.query
            getDistributionActivityInfo({
                special_id: this.special_id,
                distribution_code
            }).then(res => {
                this.reqSuccess = true
                Object.assign(this, res)
                /* 开始倒计时 */
                console.log(this.$refs.distributionCountDown)
                this.$refs.distributionCountDown.startCountDown()
                this.$emit('setHeader', {
                    title: res.share.title === '' ? res.activity_title : res.share.title,
                    showHeader: true,
                    showLeft: false
                })
                this.configWxShare(res.share)
            }).catch(err => {
                console.log(err)
                this.reqSuccess = false
            })
        },
        /**
         * 获取分销活动基本信息
         */
        async getGoodsList () {
            try {
                const res = await getDistributionActivityGoodsList({
                    special_id: this.special_id,
                    goods_name: this.goods_name,
                    page: this.page,
                    pagesize: this.pagesize,
                })
                this.list = res.list
                if (res.list.length < this.pagesize) {
                    this.page = 1
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                } else {
                    this.page++
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
            } catch (e) {}
        },
        /**
         * 上拉加载数据，在这里进行操作
         */
        scrollToEnd (scroll) {
            this.isload && this.getPageList()
        },
        /**
         * 监听是否初始化成功
         */
        init (scroll) {
            this.scroll = scroll
            this.getPageList()
        },
        /**
         * 跳转单店秒杀
        */
        goSeckill (sstore_id) {
            this.$router.push({
                path: '/seckill',
                query: {
                    sstore_id,
                    activity_id: this.$route.query.activity_id
                }
            })
        }
    }
}
